import { LoginParticipante } from './../../models/login-participante.model';
import { LoginService } from './../../services/login-participante.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanLoad, Route } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { StorageService } from '../../services/storage.service';


@Injectable({
  providedIn: 'root'
})

export class AuthGuardADMINService implements CanActivate, CanLoad {

  participante: LoginParticipante = new LoginParticipante();

  constructor(
    protected storage: StorageService,
    protected route: Router,
    protected loginServices: LoginService) { }

  protected isAuthetication() {    
    if (this.storage.getLocalUser()) {
      this.getParticipanteLogado()
      if (this.participante.role == 'ADMIN') {
        return true;
      } else {
        this.route.navigate(['/login']);
        throw new Error("Acesso Negago para esta Rota!")       
        return false;
      }
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.isAuthetication();
  }

  canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    return this.isAuthetication();
  }

  getParticipanteLogado() {
    this.loginServices.getParticipantePorLogin().subscribe(result => {
      this.participante = result;      
    }, error => {

    });
  }

}
